import React from "react";
import ThreeDFileViewer from "./ThreeDFileViewer";
import KmlFileViewer from "./KmlFileViewer";
import DocumentFileViewer from "./DocumentFileViewer";
import AudioFileViewer from "./AudioFileViewer";
import XERFileViewer from "./XERFileViewer";
import BIMFileViewer from "./BIMFileViewer";
import FallbackFileViewer from "./FallbackFileViewer";
import {
  AUDIO_EXTENSIONS,
  BIM_EXTENSIONS,
  DOCUMENT_EXTENSIONS,
  KML_EXTENSIONS,
  THREE_D_EXTENSIONS,
  XER_EXTENSIONS,
  getFileExtension,
} from "./fileUtils";

const ViewFileType = ({ file, open, onClose, projectId }) => {
  if (!open || !file) return null;

  const extension = getFileExtension(file);

  if (THREE_D_EXTENSIONS.has(extension)) {
    return <ThreeDFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  if (KML_EXTENSIONS.has(extension)) {
    return <KmlFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  if (AUDIO_EXTENSIONS.has(extension)) {
    return <AudioFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  if (DOCUMENT_EXTENSIONS.has(extension)) {
    return <DocumentFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  if (XER_EXTENSIONS.has(extension)) {
    return <XERFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  // BIM files (IFC, RVT, DWG, BIM) require conversion to GLB/GLTF for browser viewing
  if (BIM_EXTENSIONS.has(extension)) {
    return <BIMFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
  }

  return <FallbackFileViewer file={file} open={open} onClose={onClose} projectId={projectId} />;
};

export default ViewFileType;
